
export default (initialComment = null) => ({
    
    agreement: {},
    comment: initialComment,
    isEditing: false,
    quillInstance: null,
    pendingFiles: [],

    init() {
    
        this.agreement = Alpine.store('agreementManager').selectedAgreement;
        
//        if (!this.comment) {
            this.startEditing(); // Si es nuevo, inicializa de inmediato
            if ( !this.comment ) {
                this.isEditing = false;
            }
//        }

        this.$watch('isEditing', (value, oldValue) => {
            if ( value && Object.keys(this.agreement).length === 0 ) {
                this.agreement = Alpine.store('agreementManager').selectedAgreement;
            }
        });
    },
    
    destroy() {
        console.log('El componente está siendo destruido, limpiando...');
        if (this.pendingFiles.length > 0) {
            this.deleteFiles(this.pendingFiles.map(f => f.id));
        }
    },

    startEditing() {
//        this.isEditing = true;

        this.$nextTick(() => {
            if (!this.quillInstance) {
                
                this.quillInstance = new Quill(this.$refs.editorContainer, {
                    theme: 'snow',
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                            ['link']
                        ],
                        // 💡 Si usas menciones aquí, inyectas tu config de 'mention'
                        mention: {
                            allowedChars: /^[A-Za-z0-9_]*$/,
                            mentionDenotationChars: ["@"],
                            source: (searchTerm, renderList, mentionChar) => {
                                const agreement = this.agreement;
                                const collaborators = agreement ? agreement.allowed_collaborators : [];
                                const matches = collaborators.filter(u =>
                                    u.name.toLowerCase().includes(searchTerm.toLowerCase())
                                );
                                renderList(matches.map(u => ({id: u.id, value: u.name})));
                            }
                        }
                    }
                });
                
                this.quillInstance.on('text-change', (delta, oldDelta, source) => {
                    // Comparamos el delta para ver qué se eliminó
                    // Si se eliminó un atributo 'link', es un archivo
                    delta.ops.forEach(op => {
                        if (op.delete) {
                            // Aquí detectas que algo fue borrado
                            this.handleRemoval(oldDelta, delta);
                        }
                    });
                });

                this.quillInstance.root.addEventListener('remove-file', (e) => {
                    const fileId = e.detail;

                    // 1. Borrar el archivo del servidor
                    this.deleteFiles([fileId]);

                    // 2. Borrar el Blot del editor (Quill lo hace solo al eliminar el nodo)
                    // O puedes forzarlo encontrando el rango:
                    const quill = Alpine.raw(this.quillInstance);                                            
                    const element = quill.root.querySelector(`[data-id="${fileId}"]`);
                    const blot = Quill.find(element);

                    if (blot) {
                        const index = quill.getIndex(blot);
                        const length = blot.length();
                        quill.deleteText(index, length, 'user');
                    }
                });
               
            }
            
            if (this.comment) {
                this.quillInstance.root.innerHTML = this.comment.message;                
            }
                        
        });
    },
    
    cancelEditing() {
            
        this.isEditing = false;
        // Opcional: Puedes destruir o limpiar la instancia si deseas aligerar el DOM
        if (this.pendingFiles.length > 0) {
            this.deleteFiles(this.pendingFiles.map(f => f.id));
        }
        this.pendingFiles = []; // Se resetea solo para este comentario
            
        if ( !this.comment ) {
            this.quillInstance.setSelection(null);                
            this.quillInstance.root.innerHTML = '';
        }
        else {
            this.quillInstance.root.innerHTML = this.comment.message; 
        }
    },
    
//    async closed() {
//        
//        const agreement = this.agreement;
//        
//        if ( !agreement || agreement.id !== this.comment.commentable_id ) {
//            this.cancelEditing();
//        }
//        
//    },

    async saveEdition(commentId = null) {
        
        const updatedHtml = this.quillInstance.root.innerHTML;
//        const updatedText = this.quillInstance.getText().trim();
        
        const agreement = this.agreement;
            console.log(agreement);
        const url = this.comment ? route('agreements.comment.update', { agreement: agreement.id, comment: commentId }) : route('agreements.comment', {agreement: agreement.id});
        const method = this.comment ? 'PUT' : 'POST';

        if (updatedHtml.trim() === '') return;

        try {
            // 1. Envías la actualización a tu backend de Laravel

            fetch(url, { 
                method: method, 
                headers: { 
                    'Content-Type': 'application/json', 
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content 
                }, 
                body: JSON.stringify({ 
                    message: this.quillInstance.root.innerHTML,
                    file_id: this.pendingFiles.map(f => f.id),
                }) 
            })
            .then(res => res.ok ? res.json() : Promise.reject())
            .then(data => {
                
                if ( this.comment ) {
                    agreement.comments = data.comments;
                }
                else {
                    let area = this.areas.find(a => a.projects.some(p => p.id === agreement.project_id));
                    let agreementx = area.projects.find(p => p.id === agreement.project_id).agreements.find(a => a.id === agreement.id);

                    agreementx.comments = data.comments;
                    Alpine.store('agreementManager').setAgreement(agreementx);
                }
            })
            .catch(() => alert('Error al editar el comentario'));

            // seteamos el id del comentario a estos archivos
            // this.updateFiles(data.id, this.pendingFiles);
                    
            // primero limpiamos la lista de archivos para que no los borre al limpiar el texto
            this.pendingFiles = [];            

            if ( this.comment ) {
                // 2. Actualizamos la data local reactiva de Alpine para reflejar los cambios
                this.item.message = updatedHtml;
                // 3. Salimos del modo edición de forma limpia desactivando la selección primero
                this.quillInstance.setSelection(null);
            }
            else {
                this.quillInstance.setSelection(null);                
                this.quillInstance.root.innerHTML = '';
            }
            
            this.isEditing = false;
            

        } catch (error) {
            console.error("Error al actualizar el comentario:", error);
        }
    },

    deleteComment(commentId) {

        if(confirm('¿Seguro que deseas eliminar esta actualización?')) {

            const agreement = this.agreement;
            const url = route('agreements.comment.delete', { agreement: agreement.id, comment: commentId });

            fetch(url, { 
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json', 
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content 
                }, 
            })
            .then(res => res.ok ? res.json() : Promise.reject())
            .then(data => {
//                                        this.actualizaciones = this.actualizaciones.filter(u => u.id !== commentId);

                let area = this.areas.find(a => a.projects.some(p => p.id === agreement.project_id));
                let agreementx = area.projects.find(p => p.id === agreement.project_id).agreements.find(a => a.id === agreement.id);

                agreementx.comments = agreementx.comments.filter(c => c.id != commentId);
                Alpine.store('agreementManager').setAgreement(agreementx);

                Toast.fire(data.message);
            })
            .catch(() => alert('Error al editar el comentario'));

        }
    },

    async handleFileSelect(e, agreement) {

        const quill = Alpine.raw(this.quillInstance);

        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file);
        formData.append('agreement_id', agreement.id);

        // Si usas Laravel, no olvides el token CSRF
        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        if (this.comment) {
            formData.append('comment_id', this.comment.id);
        }

        try {

            const url = route('agreements.uploadFile', { agreement: agreement.id })

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    // Nota: Al usar FormData, NO definas el Content-Type. 
                    // El navegador lo detecta automáticamente y añade el boundary correcto.
                },
                body: formData
            });

            // 1. Verificar si la respuesta fue exitosa
            if (!response.ok) {
                throw new Error('Error en la subida: ' + response.statusText);
            }

            // 2. Convertir la respuesta a JSON
            const data = await response.json();
//                                    this.pendingFiles.push(data.id);
            this.pendingFiles.push({ id: data.id, url: data.url });
            console.log(this.pendingFiles.length);
            // 3. Insertar en Quill
            quill.focus();
            const range = quill.getSelection();                                    
//                                    quill.insertText(range.index, `📁 ${data.name}`, 'link', data.url);
            quill.insertEmbed(range.index, 'file-attachment', {
                id: data.id, 
                url: data.url,
                name: data.name,
                mime_type: data.mime_type,
            });

            // Livewire.dispatch('refresh-files-list');

        } catch (error) {
            console.error("Error al subir el archivo:", error);
            alert("No se pudo subir el archivo.");
        }
    },

    handleRemoval(oldDelta, delta) {
        // 1. Obtén todo el texto como objeto de Quill
        const quill = Alpine.raw(this.quillInstance);
        const currentContents = quill.getContents();

//                                const remainingUrls = currentContents.ops
//                                    .filter(op => op.attributes && op.attributes.link)
//                                    .map(op => op.attributes.link);
        const remainingUrls = currentContents.ops
            .filter(op => op.insert && op.insert["file-attachment"])
            .map(op => op.insert["file-attachment"].url);

        // 2. Filtramos lo que queda en pendingFiles
        // Nos quedamos solo con los objetos cuyo 'url' todavía existe en el editor
        const stillInEditor = this.pendingFiles.filter(file => remainingUrls.includes(file.url));

        // 3. Identificamos los que ya no están (para borrarlos del servidor)
        const toDelete = this.pendingFiles.filter(file => !remainingUrls.includes(file.url));

        // 4. Ejecutamos borrado si es necesario
        if (toDelete.length > 0) {
            const idsToDelete = toDelete.map(f => f.id);
            this.deleteFiles(idsToDelete);
        }

        // 5. Actualizamos el estado
        this.pendingFiles = stillInEditor;
    },

    async deleteFiles(fileIds) {
        
        const agreement = this.agreement;            
        const url = route('agreements.deleteFiles', {agreement: agreement.id});

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                'Accept': 'application/json'
            },
            body: JSON.stringify({ 
                file_id: fileIds
            })
        });
    },
    
    updateFiles(commendId, fileIds) {
        
        const agreement = this.agreement;            
        const url = route('agreements.updateFiles', {agreement: agreement.id});

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                'Accept': 'application/json'
            },
            body: JSON.stringify({ 
                file_id: fileIds,
                comment_id: commendId
            })
        });
    }

});